import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import SPACE_BG from "../../assets/images/space_blue.jpg";
import { ProfileCard } from "../Hero/profile-card";

gsap.registerPlugin(ScrollTrigger);

const HeroB: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useGSAP(() => {
    const ctx = gsap.context(() => {
      // Parallax background
      gsap.to(".parallax-bg", {
        yPercent: 20,
        ease: "none",
        scrollTrigger: {
          trigger: containerRef.current,
          start: "top top",
          end: "bottom top",
          scrub: true,
        },
      });

      // Profile card parallax
      gsap.from(".profile-card", {
        y: 120,
        opacity: 0,
        duration: 1.2,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".profile-section",
          start: "top 70%",
        },
      });

      // Text reveal animations
      gsap.utils.toArray<HTMLElement>(".reveal-section").forEach((section) => {
        const text = section.querySelector(".hero-text");

        gsap.from(text, {
          y: 120,
          opacity: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 75%",
          },
        });

        // subtle parallax drift
        gsap.to(text, {
          y: -80,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });
      });
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section id="hero" ref={containerRef} className="relative w-full">
      {/* Background */}
      <div className="fixed top-0 left-0 w-full h-screen -z-20 overflow-hidden">
        <img
          src={SPACE_BG}
          className="parallax-bg absolute inset-0 w-full h-full object-cover scale-110"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Profile Section */}
      <div className="profile-section min-h-screen flex items-center justify-center px-6">
        <div className="profile-card">
          <ProfileCard />
        </div>
      </div>

      {/* Section 1 */}
      <section className="reveal-section min-h-screen flex items-center justify-center text-center px-6">
        <h2 className="hero-text text-4xl md:text-6xl font-bold tracking-tight drop-shadow-xl leading-tight">
          I Build Profitable <br />
          <span className="text-primary">Full-Stack Apps.</span>
        </h2>
      </section>

      {/* Section 2 */}
      <section className="reveal-section min-h-screen flex items-center justify-center text-center px-6">
        <h2 className="hero-text text-4xl md:text-6xl font-bold tracking-tight drop-shadow-xl leading-tight">
          I Edit High-Engaging <br />
          <span className="text-primary">Video & Reels.</span>
        </h2>
      </section>
    </section>
  );
};

export default HeroB;
